let isLoading = false;
let threshold = 500;

function isNearBottomOfPage() {
  const position = window.scrollY + window.innerHeight;
  const height = document.documentElement.scrollHeight;
  return position > height - threshold;
}

async function loadNextPage(btn) {
  if (isLoading) return;
  isLoading = true;

  btn.innerHTML = `
    <div class="loading-overlay__spinner">
      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="black" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
  `;
  
  try {
    const response = await fetch(btn.dataset.nextPageUrl);
    const data = await response.text();

    const parser = new DOMParser();
    const newDocument = parser.parseFromString(data, 'text/html');

    const selectors = ['#product-grid', '.collection-list'];
    selectors.forEach(selector => {
      const currentElement = document.querySelector(selector);
      const newElement = newDocument.querySelector(selector);
      if (currentElement && newElement) {
        currentElement.insertAdjacentHTML('beforeend', newElement.innerHTML);
      }
    });

    const paginationContainer = newDocument.querySelector('#custom-infinite-pagination');
    if (paginationContainer) {
      document.querySelector('#custom-infinite-pagination').innerHTML = paginationContainer.innerHTML;
    }

   
    initializeProductCardSliders();

    const event = new CustomEvent('eg.paginate.next');
    document.dispatchEvent(event);

  
    threshold = 500; 

  } catch (error) {
    console.error('Error loading next page:', error);
  } finally {
    isLoading = false;
  }
}

window.addEventListener('scroll', () => {
  if (isNearBottomOfPage()) {
    const nextPageBtn = document.querySelector('[data-next-page-url]');
    if (nextPageBtn && !isLoading) {
      loadNextPage(nextPageBtn);
    }
  }
});

window.egLoadNextPage = function(btn) {
  loadNextPage(btn);
};
